"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var currency_1 = require("../../../../utils/currency");
var product_1 = require("../../ducks/product");
var GenericSelect_1 = __importDefault(require("../../../common/GenericSelect"));
var quantity_module_scss_1 = __importDefault(require("./quantity.module.scss"));
var Quantity = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var _a = (0, react_redux_1.useSelector)(product_1.productSelector), circulations = _a.circulations, condition = _a.condition;
    var currency = (0, react_redux_1.useSelector)(function (state) { return state.currency; });
    var options = Array.isArray(circulations) ? circulations.map(function (_a) {
        var minQuantity = _a.minQuantity, pricePerItem = _a.pricePerItem;
        return ({
            label: "".concat(minQuantity, " \u0448\u0442. - ").concat(pricePerItem).concat((0, currency_1.shortCurrency)(currency, pricePerItem), " \u0437\u0430 \u0448\u0442."),
            value: minQuantity.toString(),
        });
    }) : [];
    return (react_1.default.createElement("div", { className: quantity_module_scss_1.default.root },
        react_1.default.createElement("span", null, "\u0422\u0438\u0440\u0430\u0436:"),
        react_1.default.createElement(GenericSelect_1.default, { className: quantity_module_scss_1.default.select, options: options, value: condition.quantity.toString(), onChange: function (e) { return dispatch((0, product_1.setQuantity)(Number(e))); }, renderOption: function (label) { return react_1.default.createElement("span", null, label); }, renderValue: function (value) { return react_1.default.createElement("span", null, "".concat(value, " \u0448\u0442.")); } })));
};
exports.default = Quantity;
